import {
  LOGIN,
  LOGOUT,
  SET_NAME,
  SET_EMAIL,
  SET_PROFILE,
  SET_COUNT,
  SET_ROLE,
  SET_CHANGE_EMAIL,
  SET_USER_ID,
  SET_TEAM_NAME
} from "../actions/types";

const initialState = {
  accessToken: sessionStorage.getItem("accessToken"),
  name: "",
  image: "",
  email: "",
  url: "",
  count: "",
  role: "",
  changeEmail: "",
  userId: "",
  teamName: ""
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        ...action.payload
      };

    case LOGOUT:
      return {
        accessToken: ""
      };

    case SET_NAME:
      return {
        ...state,
        ...action.payload
      };

    case SET_EMAIL:
      return {
        ...state,
        ...action.payload
      };

    case SET_CHANGE_EMAIL:
      return {
        ...state,
        ...action.payload
      };

    case SET_PROFILE:
      return {
        ...state,
        ...action.payload
      };

    case SET_COUNT:
      return {
        ...state,
        ...action.payload
      };

    case SET_ROLE:
      return {
        ...state,
        ...action.payload
      };

    case SET_USER_ID:
      return {
        ...state,
        ...action.payload
      };

    case SET_TEAM_NAME:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
}
